import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ITranslation } from "src/app/classes/ITranslation";
import { TranslateModalErrorMapper } from "src/app/classes/translateModalErrorMapper";
import { SettingsmanagerService } from "src/app/services/settingsmanager.service";

@Component({
  selector: "app-translation-warning",
  templateUrl: "./translation-warning.component.html",
  styleUrls: ["./translation-warning.component.scss"],
})
export class TranslationWarningComponent implements OnChanges {
  @Input() translations: ITranslation[] = [];

  public translationWarning = "";

  constructor(private settingsManager: SettingsmanagerService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['translations']) {
      this.translationWarning = TranslateModalErrorMapper.mapTranslationWarning(
        this.translations,
        this.settingsManager
      );
    }
    console.log('translationwearning: ', this.translationWarning)
  }
}
